import { render } from "./GuiSquadSearchTermsSelect.vue?vue&type=template&id=395a9fab"
import script from "./GuiSquadSearchTermsSelect.vue?vue&type=script&lang=js"
export * from "./GuiSquadSearchTermsSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__